import React, { useState, useEffect } from 'react';
import { useLocation } from 'wouter';
import Header from './Header';

export default function Activate() {
  const [location, setLocation] = useLocation();
  const [formData, setFormData] = useState({
    deviceLocation: '',
    pairingcode: '',
    description: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);


  // Get activation code from URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      setFormData(prev => ({ ...prev, pairingcode: code }));
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Validate device location
    if (!formData.deviceLocation) {
      newErrors.deviceLocation = "Device Location is required";
      isValid = false;
    }

    // Validate pairing code
    if (!formData.pairingcode) {
      newErrors.pairingcode = "Please enter the activation code displayed on your TV Screen";
      isValid = false;
    } else if (formData.pairingcode.length < 4) {
      newErrors.pairingcode = "Invalid activation code";
      isValid = false;
    }

    // Validate description if "other" is selected
    if (formData.deviceLocation === 'other' && !formData.description) {
      newErrors.description = "Description is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Clear errors for the field being changed
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Call the device activation API
      const response = await addDevice(formData);
      console.log('Activation response:', response);
      if (response.success) {
        setSuccess(true);
        console.log('Device activated successfully:', formData);

        // Redirect after success
        setTimeout(() => {
          setLocation('/dashboard');
        }, 2000);
      } else {
        // Display the specific error message from the API
        setErrors({ submit: response.message || 'Activation failed' });
      }

    } catch (error) {
      console.error('Activation failed:', error);
      setErrors({ submit: 'Network error. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  // Device activation API call function
  const addDevice = async (bodydata) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const appname = window.app.appName;
      const environmentVariable = window.app.appEnvName;
      const lambdaUrl = window.site.screeningApiBaseUrl;
      let url;
      if (bodydata && bodydata.deviceLocation === "other") {
        url = `${lambdaUrl}/adddevice?appname=${appname}&env=${environmentVariable}&token=${token}&pairingcode=${bodydata.pairingcode}&location=${bodydata.deviceLocation}&description=${bodydata.description}`;
      } else if (bodydata && bodydata.deviceLocation) {
        url = `${lambdaUrl}/adddevice?appname=${appname}&env=${environmentVariable}&token=${token}&pairingcode=${bodydata.pairingcode}&location=${bodydata.deviceLocation}`;
      } else {
        url = `${lambdaUrl}/adddevice?appname=${appname}&env=${environmentVariable}&token=${token}&pairingcode=${bodydata.pairingcode}`;
      }

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      console.log('Raw API response:', data);

      // Check for error in the main response
      if (data.msg && (data.msg.includes('Invalid') || data.msg.includes('already paired'))) {
        console.log('Error found in data.msg:', data.msg);
        return { success: false, message: data.msg };
      }

      // Check for error in the result object
      if (data.result && data.result.msg && (data.result.msg.includes('Invalid') || data.result.msg.includes('already paired'))) {
        console.log('Error found in data.result.msg:', data.result.msg);
        return { success: false, message: data.result.msg };
      }

      // Check for any error message in the response
      if (data.msg) {
        console.log('General error in data.msg:', data.msg);
        return { success: false, message: data.msg };
      }

      // Check for any error message in result
      if (data.result && data.result.msg) {
        console.log('General error in data.result.msg:', data.result.msg);
        return { success: false, message: data.result.msg };
      }

      // Check for successful response
      if (data.statusCode === 200) {
        console.log('Success response detected');
        return { success: true, data: data.result };
      }

      // Default error case
      console.log('Default error case');
      return { success: false, message: 'Device activation failed' };

    } catch (error) {
      console.error('API call failed:', error);
      return { success: false, message: error.message };
    }
  };

  const handleCancel = () => {
    window.location = '/';
  };
  const handleHome = () => {
    window.location = '/';
  };

  const s = {
    page:      { backgroundColor: 'var(--bgColor)', minHeight: '100vh' },
    body:      { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 53px)', padding: '24px 16px' },
    card:      { backgroundColor: 'var(--secbgColor)', borderRadius: '8px', padding: '32px', width: '100%', maxWidth: '440px' },
    title:     { color: 'var(--sectxtColor)', fontSize: '22px', fontWeight: '600', textAlign: 'center', marginBottom: '24px' },
    label:     { color: 'var(--sectxtColor)', fontSize: '13px', fontWeight: '500', marginBottom: '6px', display: 'block' },
    inputWrap: { border: '1px solid #39404e', borderRadius: '4px', padding: '10px 12px', marginBottom: '4px', position: 'relative', display: 'flex', alignItems: 'center' },
    field:     { background: 'transparent', border: 'none', outline: 'none', width: '100%', color: '#c2d0ec', fontSize: '14px', padding: 0, height: 'auto' },
    hint:      { color: '#6f7685', fontSize: '13px', textAlign: 'center', margin: '8px 0 16px' },
    errText:   { color: '#FD2222', fontSize: '12px', marginBottom: '8px' },
    errSubmit: { color: '#FD2222', fontSize: '13px', marginBottom: '8px' },
    btnRow:    { display: 'flex', gap: '8px', marginTop: '8px' },
    cancelBtn: { flex: 1, height: '42px', borderRadius: '4px', border: '1px solid var(--borderColor)', background: 'transparent', color: 'var(--sectxtColor)', cursor: 'pointer', fontWeight: '600', fontSize: '13px', letterSpacing: '0.5px', padding: '10px' },
    submitBtn: { flex: 1, height: '42px', borderRadius: '4px', border: 'none', background: '#2B44FF', color: '#fff', cursor: 'pointer', fontWeight: '600', fontSize: '13px', letterSpacing: '0.5px', padding: '10px' },
    arrow:     { position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#2B44FF', fontSize: '20px' },
    spinner:   { display: 'inline-block', width: '40px', height: '40px', border: '3px solid rgba(255,255,255,.15)', borderRadius: '50%', borderTopColor: '#2B44FF', animation: 'spin 1s ease-in-out infinite', margin: '0 auto 16px' },
    successIcon: { fontSize: '64px', color: '#0FD70B', display: 'block', textAlign: 'center', marginBottom: '16px' },
  };

  if (success) {
    return (
      <div style={s.page}>
        <Header />
        <div style={s.body}>
          <div style={{ ...s.card, textAlign: 'center' }}>
            <span className="material-symbols-outlined" style={s.successIcon}>check_circle</span>
            <h2 style={{ ...s.title, marginBottom: '12px' }}>Device Activated Successfully</h2>
            <p style={s.hint}>Your device has been added to your account.</p>
            <button style={{ ...s.submitBtn, width: '100%', marginTop: '8px' }} onClick={(e) => handleHome(e)}>
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={s.page}>
        <Header />
        <div style={s.body}>
          <div style={{ ...s.card, textAlign: 'center' }}>
            <div style={s.spinner} />
            <h2 style={s.title}>Activating Your Device</h2>
            <p style={s.hint}>Please wait while we activate your device...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <Header />
      <div style={s.body}>
        <div style={s.card}>
          <h2 style={s.title}>Activate Your Device</h2>

          <form onSubmit={handleSubmit} style={{ display: 'block' }}>
            <div style={{ marginBottom: '16px' }}>
              <label style={s.label}>Select Location</label>
              <div style={s.inputWrap}>
                <select
                  name="deviceLocation"
                  value={formData.deviceLocation}
                  onChange={handleChange}
                  style={{ ...s.field, paddingRight: '24px', cursor: 'pointer', color: '#2B44FF' }}
                >
                  <option value="">Select Location</option>
                  <option value="home">Home</option>
                  <option value="office">Office</option>
                  <option value="other">Other</option>
                </select>
                <span className="material-symbols-outlined" style={s.arrow}>arrow_drop_down</span>
              </div>
              {errors.deviceLocation && <p style={s.errText}>{errors.deviceLocation}</p>}
            </div>

            {formData.deviceLocation === 'other' && (
              <div style={{ marginBottom: '16px' }}>
                <label style={s.label}>Description</label>
                <div style={s.inputWrap}>
                  <input
                    type="text"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter device location description"
                    style={s.field}
                  />
                </div>
                {errors.description && <p style={s.errText}>{errors.description}</p>}
              </div>
            )}

            <p style={s.hint}>Please enter the activation code displayed on your TV Screen.</p>

            <div style={{ marginBottom: '16px' }}>
              <div style={s.inputWrap}>
                <input
                  type="text"
                  name="pairingcode"
                  value={formData.pairingcode}
                  onChange={handleChange}
                  placeholder="ACTIVATION CODE"
                  style={{ ...s.field, textTransform: 'uppercase', letterSpacing: '1px' }}
                />
              </div>
              {errors.pairingcode && <p style={s.errText}>{errors.pairingcode}</p>}
            </div>

            {errors.submit && <p style={s.errSubmit}>{errors.submit}</p>}

            <div style={s.btnRow}>
              <button type="button" onClick={handleCancel} style={s.cancelBtn}>CANCEL</button>
              <button type="submit" disabled={loading} style={s.submitBtn}>SUBMIT</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}